import React, { useCallback, useEffect, useRef, useState } from "react";
import { useNavigate } from "react-router-dom";
import Header from "./header/header";
import Footer from "./Footer";
import axios from "axios";
import { ToastContainer, toast } from "react-toastify";
import "./doyenaccesSuccess.css";
import { BsEmojiFrown } from "react-icons/bs";
import { Modal } from "react-bootstrap";
import { baseUrl, GetToken, getUserCountry } from "../App";
import { useCourses } from "./Contexts/CoursesContext";
import { generateReceipt } from "./generatePaymentReceipt";

const DoyenaccessSuccess = () => {
  const navigate: any = useNavigate();
  const [completes, setCompletes] = useState(true);
  const track = useRef(0);
  const [showModal, setShowModal] = React.useState(false);
  const [modalContent, setModalContent] = React.useState("");
  const {courses} = useCourses();

  const handleModalClose = () => {
    setShowModal(false);
    setModalContent("");
  };

  const successaction = useCallback(async () => {
    if (track.current === 0) {
      track.current = 1;
    const idToken = await GetToken();


    var dataForReceipt: any = localStorage.getItem(
      "doyen-access-dataform"
    );
    var parsedObjectForReceipt = JSON.parse(dataForReceipt);
      const forReceiptGeneration = {
        Name: parsedObjectForReceipt.Name,
        Email: parsedObjectForReceipt.Email.toLowerCase(),
        Phone: parsedObjectForReceipt.Phone,
        Degree: parsedObjectForReceipt.Degree,
        NyscCN: parsedObjectForReceipt.NyscCN,
        YearsofExp: parsedObjectForReceipt.YearsofExp,
        FieldofStudy: parsedObjectForReceipt.FieldofStudy,
        Country: parsedObjectForReceipt.Country,
        TargetofMent: parsedObjectForReceipt.TargetofMent,
        Transition: parsedObjectForReceipt.Transition,
        Communication: parsedObjectForReceipt.Communication,
        Frequency: parsedObjectForReceipt.Frequency,
        Goal: parsedObjectForReceipt.Goal,
        Request: parsedObjectForReceipt.Request,
        Medium: parsedObjectForReceipt.Medium,
        Comment: parsedObjectForReceipt.Comment,
        sessionid: parsedObjectForReceipt.getItem("sessiontrackidss"),
        sessionid2: parsedObjectForReceipt.getItem("sessiontrackidss"),
        counts: "full",
        typepay: "fullpayment",
        typepaystage: "complete",
        product: parsedObjectForReceipt.product,
        price: parsedObjectForReceipt.price,
      };

      let userDetails = await getUserCountry();
      let currency = "";
      switch (userDetails.continentCode) {
        case "EU":
          currency="€";
          break;
        case "AF":
          if (userDetails.countryCode === "NG") {
            currency="₦";
          } else {
            currency="$";
          }
          break;
        default:
          currency="$";
      }

      let generatedReceipt = await generateReceipt(
        forReceiptGeneration.Name, "",
        forReceiptGeneration.Email,
        forReceiptGeneration.product,
        "full",
        currency,
        0,
        forReceiptGeneration.price,
        forReceiptGeneration.price,
        forReceiptGeneration.price,
      );
      const  uint8ArrayToBase64=(uint8Array:any) => {
        let binaryString = '';
        for (let i = 0; i < uint8Array.byteLength; i++) {
          binaryString += String.fromCharCode(uint8Array[i]);
        }
        return btoa(binaryString);
      }
      const base64Content = uint8ArrayToBase64(generatedReceipt);



            var data2 = courses || []
              for (const [key, value] of Object.entries(data2)) {
                var value1: any;
                value1 = key;
                value1 = value;

                if (
                  localStorage.getItem("doyen-access-dataform") &&
                  localStorage.getItem("installmentpresent")
                ) {
                  var retrievedObject: any = localStorage.getItem(
                    "doyen-access-dataform"
                  );
                  var parsedObject = JSON.parse(retrievedObject);

                  if (localStorage.getItem("installmentpresent") === "false") {
                    const body = {
                      Name: parsedObject.Name,
                      Email: parsedObject.Email.toLowerCase(),
                      Phone: parsedObject.Phone,
                      Degree: parsedObject.Degree,
                      NyscCN: parsedObject.NyscCN,
                      YearsofExp: parsedObject.YearsofExp,
                      FieldofStudy: parsedObject.FieldofStudy,
                      Country: parsedObject.Country,
                      TargetofMent: parsedObject.TargetofMent,
                      Transition: parsedObject.Transition,
                      Communication: parsedObject.Communication,
                      Frequency: parsedObject.Frequency,
                      Goal: parsedObject.Goal,
                      Request: parsedObject.Request,
                      Medium: parsedObject.Medium,
                      Comment: parsedObject.Comment,
                      sessionid: localStorage.getItem("sessiontrackidss"),
                      trackemail: value1["email"],
                      sessionid2: localStorage.getItem("sessiontrackidss"),
                      counts: "full",
                      typepay: "fullpayment",
                      typepaystage: "complete",
                      product: parsedObject.product,
                      price: parsedObject.price,
                    };
                    const bodytouser = {
                      sender: {
                        name: "DoyenifyAcademy",
                        email: "info@doyenify.com",
                      },
                      to: [
                        {
                          email: parsedObject.Email,
                        },
                      ],replyTo:{
                        email:"info.doyenify@gmail.com",
                      },
                      subject:
                        "Confirmation: Registration for {{params.product}} package for the DoyenAccess program was successful",
                      htmlContent: `<html><head>

                                                <style>
                                                    body {
                                                        background-color:#696969;
                                                    }
                                                    .imgtag{
                                                        justify-content: center;
                                                        align-items: center;
                                                        margin-left: 45%;
                                                    }
                                                    .welcome {
                                                        text-align: center;
                                                        color: #696969;
                                                    }
                                            
                                                    .content {
                                                        background-color: #ffffff;
                                                        margin: 15px;
                                                        padding: 20px;
                                                    }
                                                </style>
                                            </head>
                                            
                                            <body>
                                                <div class="imgtag">
                                                    <img src="https://academy.doyenify.com/images/doyenifyAcademy.png" alt="img" /> 
                                                </div>
                                                
                                                <div class="content">
                                                    <p>Dear {{params.name}},</p> 
                                                    <p style="margin-bottom: 10px">We are delighted to inform you that your registration for the {{params.product}} has been successfully processed. Welcome to our service!</p>

                                                    
                                                    <p>We're thrilled to welcome you as a participant and are confident that you'll discover this service to be both beneficial and captivating. Whether you're seeking skill enhancement or exploring new opportunities, we believe this service will surpass your expectations.</p>

                                                    


                                                    <p>If you have any questions, please don't hesitate to reach out to our support team at info.doyenify@gmail.com .</p>
                                                    
                                                    <p>Thank you once again for choosing Us.</p>

                                                    <p>Best regards,</p>  
                                                    <p>DoyenifyAcademy</p>
                                                </div>
                                            
                                                
                                            </body>
                                            </html>
                                                            
                                                        `,
                      params: {
                        product: parsedObject.product,
                        name: parsedObject.Name,
                      },
                      attachment: [
                        {
                          name: "Payment Receipt.pdf",
                          content: base64Content,
                        },
                      ],
                    };

                    const bodytodoyen = {
                      sender: {
                        name: "Doyenify Academy Notification",
                        email: "info@doyenify.com",
                      },
                      to: [
                        {
                          email: "info.doyenify@gmail.com",
                        },
                      ],replyTo:{
                        email:"info.doyenify@gmail.com",
                      },
                      subject:
                        "Someone registered for DoyenAccess service '{{params.product}}'",
                      htmlContent: `<html><head></head><body>
                                                                <h1>you have a newly registered user for the DoyenAccess program</h1>
                                                                <p>Package Name: {{params.product}}</p>
                                                                <p>Package Price: $ {{params.price}}</p>
                                                                <p>Person's Name: {{params.name}}, registered</p>
                                                                <p>Person's Email: {{params.email}}</p>
                                                                <p>Person's Phone Number: {{params.phone}}</p>
                                                                
                                                                
                                                            </body></html>`,
                      params: {
                        product: parsedObject.product,
                        price: parsedObject.price,
                        email: parsedObject.Email,
                        phone: parsedObject.Phone,
                        name: parsedObject.Name,
                      },
                      attachment: [
                        {
                          name: "Payment Receipt.pdf",
                          content: base64Content,
                        },
                      ],
                    };
                    await axios
                      .post(
                        `${baseUrl}/accessdoyen`,
                        body,
                        {
                          headers: {
                            Authorization: `Bearer ${idToken}`,
                          },
                        }
                      )
                      .then(async(response) => {
                        localStorage.removeItem("doyen-access-dataform");
                        localStorage.removeItem("installmentpresent");
                        localStorage.removeItem("sessiontrackidss");

                        const responseToken = await fetch("https://identitytoolkit.googleapis.com/v1/accounts:signInWithPassword?key=" +
                          process.env.REACT_APP_SERVICE_KEY, {
                          method: "post",
                          body: JSON.stringify({
                            email: process.env.REACT_APP_SERVICE_EMAIL,
                            password: process.env.REACT_APP_SERVICE_PASSWORD,
                            returnSecureToken: true,
                          }),
                          headers: {
                            "Content-Type": "application/json",
                          },
                        });

                        const userToken = await responseToken.json();
                        await axios
                        .post(String(process.env.REACT_APP_SERVICE_APP_URL), bodytouser, {
                            headers: { Authorization: `Bearer ${userToken.idToken}` },
                          }
                        )
                        .then()
                        .catch(() => {
                          console.log("(axios) an error occurred")
                        });

                        await axios
                        .post(String(process.env.REACT_APP_SERVICE_APP_URL), bodytodoyen, {
                            headers: { Authorization: `Bearer ${userToken.idToken}` },
                          }
                        )
                        .then()
                        .catch(() => {
                          console.log("(axios) an error occurred")
                        });

                       
                        setCompletes(true);
                        toast("Payment process completed");
                      })
                      .catch((error) => {
                        console.log(error);
                        toast("Something wrong");
                      });
                  } else if (
                    localStorage.getItem("installmentpresent") === "true"
                  ) {
                    if (localStorage.getItem("Firststallpayment") === "first") {
                     const body = {
                        Name: parsedObject.Name,
                        Email: parsedObject.Email,
                        Phone: parsedObject.Phone,
                        Degree: parsedObject.Degree,
                        NyscCN: parsedObject.NyscCN,
                        YearsofExp: parsedObject.YearsofExp,
                        FieldofStudy: parsedObject.FieldofStudy,
                        Country: parsedObject.Country,
                        TargetofMent: parsedObject.TargetofMent,
                        Transition: parsedObject.Transition,
                        Communication: parsedObject.Communication,
                        Frequency: parsedObject.Frequency,
                        Goal: parsedObject.Goal,
                        Request: parsedObject.Request,
                        Medium: parsedObject.Medium,
                        Comment: parsedObject.Comment,
                        sessionid: localStorage.getItem("sessiontrackidss"),
                        trackemail: value1["email"],
                        sessionid2: localStorage.getItem("sessiontrackidss"),
                        counts: "first",
                        typepay: "installment",
                        typepaystage: "first",
                        product: parsedObject.product,
                        price: String(
                          Math.ceil(Number(parsedObject.price) * 0.7)
                        ),
                      };

                      const bodytouser = {
                        sender: {
                          name: "Doyenify Academy",
                          email: "info@doyenify.com",
                        },
                        to: [
                          {
                            email: parsedObject.Email,
                          },
                        ],
                        replyTo:{
                          email:"info.doyenify@gmail.com",
                        },
                        subject:
                          "Confirmation: Your First Installment payment for {{params.product}} package for the DoyenAccess program was successful",
                        htmlContent: `<html><head>

                                                    <style>
                                                        body {
                                                            background-color:#696969;
                                                        }
                                                        .imgtag{
                                                            justify-content: center;
                                                            align-items: center;
                                                            margin-left: 45%;
                                                        }
                                                        .welcome {
                                                            text-align: center;
                                                            color: #696969;
                                                        }
                                                
                                                        .content {
                                                            background-color: #ffffff;
                                                            margin: 15px;
                                                            padding: 20px;
                                                        }
                                                    </style>
                                                </head>
                                                
                                                <body>
                                                    <div class="imgtag">
                                                        <img src="https://academy.doyenify.com/images/doyenifyAcademy.png" alt="img" /> 
                                                    </div>
                                                    
                                                    <div class="content">
                                                        <p>Dear {{params.name}},</p> 
                                                        <p style="margin-bottom: 10px">We are delighted to inform you that your first installmental payment for the {{params.product}} has been successfully processed. Welcome to our service!</p>

                                                        
                                                        <p>We're thrilled to welcome you as a participant and are confident that you'll discover this service to be both beneficial and captivating. Whether you're seeking skill enhancement or exploring new opportunities, we believe this service will surpass your expectations.</p>

                                                        


                                                        <p>If you have any questions, please don't hesitate to reach out to our support team at info.doyenify@gmail.com .</p>
                                                        
                                                        <p>Thank you once again for choosing Us.</p>

                                                        <p>Best regards,</p>  
                                                        <p>DoyenifyAcademy</p>
                                                    </div>
                                                
                                                    
                                                </body>
                                                </html>
                                                                
                                                            `,
                        params: {
                          product: parsedObject.product,
                          name: parsedObject.Name,
                        },
                        attachment: [
                          {
                            name: "Payment Receipt.pdf",
                            content: base64Content,
                          },
                        ],
                      };

                      const bodytodoyen = {
                        sender: {
                          name: "Doyenify Academy Notification",
                          email: "info@doyenify.com",
                        },
                        to: [
                          {
                            email: "info.doyenify@gmail.com",
                          },
                        ],
                        replyTo:{
                          email:"info.doyenify@gmail.com",
                        },
                        subject:
                          "Someone registered with first installmental payment for DoyenAccess service '{{params.product}}'",
                        htmlContent: `<html><head></head><body>
                                                                    <h1>you have a newly registered user for the DoyenAccess program</h1>
                                                                    <p>Package Name: {{params.product}}</p>
                                                                    <p>Package Price: $ {{params.price}}</p>
                                                                    <p>Person's Name: {{params.name}}, registered</p>
                                                                    <p>Person's Email: {{params.email}}</p>
                                                                    <p>Person's Phone Number: {{params.phone}}</p>
                                                                    <p>Installment payment: true</p>
                                                                    <p>installment: first</p>
                                                                    
                                                                    
                                                                </body></html>`,
                        params: {
                          product: parsedObject.product,
                          price: String(
                            Math.ceil(Number(parsedObject.price) * 0.7)
                          ),
                          email: parsedObject.Email,
                          phone: parsedObject.Phone,
                          name: parsedObject.Name,
                        },
                        attachment: [
                          {
                            name: "Payment Receipt.pdf",
                            content: base64Content,
                          },
                        ],
                      };
                     await axios
                        .post(
                          `${baseUrl}/accessdoyen`,
                          body,
                          {
                            headers: {
                              Authorization: `Bearer ${idToken}`,
                            },
                          }
                        )
                        .then(async(response) => {
                          localStorage.removeItem("doyen-access-dataform");
                          localStorage.removeItem("installmentpresent");
                          localStorage.removeItem("sessiontrackidss");
                          localStorage.removeItem("Firststallpayment");

                          const responseToken = await fetch("https://identitytoolkit.googleapis.com/v1/accounts:signInWithPassword?key=" +
                              process.env.REACT_APP_SERVICE_KEY, {
                              method: "post",
                              body: JSON.stringify({
                                email: process.env.REACT_APP_SERVICE_EMAIL,
                                password: process.env.REACT_APP_SERVICE_PASSWORD,
                                returnSecureToken: true,
                              }),
                              headers: {
                                "Content-Type": "application/json",
                              },
                            });

                            const userToken = await responseToken.json();
                            await axios
                            .post(String(process.env.REACT_APP_SERVICE_APP_URL), bodytouser, {
                                headers: { Authorization: `Bearer ${userToken.idToken}` },
                              }
                            )
                            .then()
                            .catch((e) => {
                              console.log("(axios) an error occurred", e)
                            });

                            await axios
                            .post(String(process.env.REACT_APP_SERVICE_APP_URL), bodytodoyen, {
                                headers: { Authorization: `Bearer ${userToken.idToken}` },
                              }
                            )
                            .then()
                            .catch((e) => {
                              console.log("(axios) an error occurred", e)
                            });

                          
                          setCompletes(true);
                          toast("Payment process completed");
                        })
                        .catch((error) => {
                          console.log(error);
                          localStorage.removeItem("doyen-access-dataform");
                          localStorage.removeItem("installmentpresent");
                          localStorage.removeItem("sessiontrackidss");
                          toast("Something wrong");
                        });
                    }

                    if (
                      localStorage.getItem("Firststallpayment") === "second"
                    ) {
                     await axios
                        .get(
                          `${baseUrl}/accessdoyen/` +
                            localStorage.getItem("doyenaccesid"),
                          {
                            headers: {
                              Authorization: `Bearer ${idToken}`,
                            },
                          }
                        )
                        .then((response) => {
                          const bodys = {
                            Name: response.data.data.Name,
                            Email: response.data.data.Email,
                            Phone: response.data.data.Phone,
                            Degree: response.data.data.Degree,
                            NyscCN: response.data.data.NyscCN,
                            YearsofExp: response.data.data.YearsofExp,
                            FieldofStudy: response.data.data.FieldofStudy,
                            Country: response.data.data.Country,
                            TargetofMent: response.data.data.TargetofMent,
                            Transition: response.data.data.Transition,
                            Communication: response.data.data.Communication,
                            Frequency: response.data.data.Frequency,
                            Goal: response.data.data.Goal,
                            Request: response.data.data.Request,
                            Medium: response.data.data.Medium,
                            Comment: response.data.data.Comment,
                            sessionid: localStorage.getItem("sessiontrackidss"),
                            trackemail: response.data.data.trackemail,
                            sessionid2:
                              localStorage.getItem("sessiontrackidss"),
                            counts: "last",
                            typepay: "installment",
                            typepaystage: "second",
                            product: response.data.data.product,
                            price: localStorage.getItem("priceaccess"),
                          };

                          const bodytouser = {
                            sender: {
                              name: "DoyenifyAcademy",
                              email: "info@doyenify.com",
                            },
                            to: [
                              {
                                email: response.data.data.Email,
                              },
                            ],
                            replyTo:{
                              email:"info.doyenify@gmail.com",
                            },
                            subject:
                              "Confirmation: Your Installment payment for {{params.product}} package for the DoyenAccess program was successful",
                            htmlContent: `<html><head>
        
                                                            <style>
                                                                body {
                                                                    background-color:#696969;
                                                                }
                                                                .imgtag{
                                                                    justify-content: center;
                                                                    align-items: center;
                                                                    margin-left: 45%;
                                                                }
                                                                .welcome {
                                                                    text-align: center;
                                                                    color: #696969;
                                                                }
                                                        
                                                                .content {
                                                                    background-color: #ffffff;
                                                                    margin: 15px;
                                                                    padding: 20px;
                                                                }
                                                            </style>
                                                        </head>
                                                        
                                                        <body>
                                                            <div class="imgtag">
                                                                <img src="https://academy.doyenify.com/images/doyenifyAcademy.png" alt="img" /> 
                                                            </div>
                                                            
                                                            <div class="content">
                                                                <p>Dear {{params.name}},</p> 
                                                                <p style="margin-bottom: 10px">We are delighted to inform you that your installmental payment for the {{params.product}} has been successfully Completed. Welcome to our service!</p>

                                                                
                                                                <p>We're thrilled to welcome you as a participant and are confident that you'll discover this service to be both beneficial and captivating. Whether you're seeking skill enhancement or exploring new opportunities, we believe this service will surpass your expectations.</p>

                                                                


                                                                <p>If you have any questions, please don't hesitate to reach out to our support team at info.doyenify@gmail.com .</p>
                                                                
                                                                <p>Thank you once again for choosing Us.</p>

                                                                <p>Best regards,</p>  
                                                                <p>DoyenifyAcademy</p>
                                                            </div>
                                                        
                                                            
                                                        </body>
                                                        </html>
                                                                        
                                                                    `,
                            params: {
                              product: response.data.data.product,
                              name: response.data.data.Name,
                            },
                            attachment: [
                              {
                                name: "Payment Receipt.pdf",
                                content: base64Content,
                              },
                            ],
                          };

                          const bodytodoyen = {
                            sender: {
                              name: "Doyenify Academy Notification",
                              email: "info@doyenify.com",
                            },
                            to: [
                              {
                                email: "info.doyenify@gmail.com",
                              },
                            ],
                            replyTo:{
                              email:"info.doyenify@gmail.com",
                            },
                            subject:
                              "Someone registered with first installmental payment for DoyenAccess service '{{params.product}}'",
                            htmlContent: `<html><head></head><body>
                                                                            <h1>you have a newly registered user for the DoyenAccess program</h1>
                                                                            <p>Package Name: {{params.product}}</p>
                                                                            <p>Package Price: $ {{params.price}}</p>
                                                                            <p>Person's Name: {{params.name}}, registered</p>
                                                                            <p>Person's Email: {{params.email}}</p>
                                                                            <p>Person's Phone Number: {{params.phone}}</p>
                                                                            <p>Installment payment: true</p>
                                                                            <p>installment: second</p>
                                                                            
                                                                            
                                                                        </body></html>`,
                            params: {
                              product: response.data.data.product,
                              price: String(
                                Math.ceil(
                                  Number(response.data.data.price) * 0.3
                                )
                              ),
                              email: response.data.data.Email,
                              phone: response.data.data.Phone,
                              name: response.data.data.Name,
                            },
                            attachment: [
                              {
                                name: "Payment Receipt.pdf",
                                content: base64Content,
                              },
                            ],
                          };

                         axios
                            .patch(
                              `${baseUrl}/accessdoyen/` +
                                localStorage.getItem("doyenaccesid"),
                              bodys,
                              {
                                headers: {
                                  Authorization: `Bearer ${idToken}`,
                                },
                              }
                            )
                            .then(async(responsesecondaccess) => {
                              localStorage.removeItem("doyen-access-dataform");
                              localStorage.removeItem("installmentpresent");
                              localStorage.removeItem("sessiontrackidss");
                              localStorage.removeItem("Firststallpayment");
                              localStorage.removeItem("doyenaccesid");
                              localStorage.removeItem("priceaccess");

                              const responseToken = await fetch("https://identitytoolkit.googleapis.com/v1/accounts:signInWithPassword?key=" +
                              process.env.REACT_APP_SERVICE_KEY, {
                              method: "post",
                              body: JSON.stringify({
                                email: process.env.REACT_APP_SERVICE_EMAIL,
                                password: process.env.REACT_APP_SERVICE_PASSWORD,
                                returnSecureToken: true,
                              }),
                              headers: {
                                "Content-Type": "application/json",
                              },
                            });

                            const userToken = await responseToken.json();
                            await axios
                            .post(String(process.env.REACT_APP_SERVICE_APP_URL), bodytouser, {
                                headers: { Authorization: `Bearer ${userToken.idToken}` },
                              }
                            )
                            .then()
                            .catch((e) => {
                              console.log("(axios) an error occurred", e)
                            });


                            await axios
                            .post(String(process.env.REACT_APP_SERVICE_APP_URL), bodytodoyen, {
                                headers: { Authorization: `Bearer ${userToken.idToken}` },
                              }
                            )
                            .then()
                            .catch((e) => {
                              console.log("(axios) an error occurred", e)
                            });

                              
                              setCompletes(true);
                              toast("Payment process completed");
                            })
                            .catch((error) => {
                              console.log(error);
                              localStorage.removeItem("doyen-access-dataform");
                              localStorage.removeItem("installmentpresent");
                              localStorage.removeItem("sessiontrackidss");
                              localStorage.removeItem("doyenaccesid");
                              localStorage.removeItem("priceaccess");
                              toast("Something wrong");
                            });
                        });
                    }
                  }
                } else {
                  //console.log("No data form")
                }
              }
    }
  }, [courses]);

  useEffect(() => {
    successaction();
  }, [successaction]);

  return (
    <div>
      <Modal show={showModal} onHide={handleModalClose} centered={true}>
        <Modal.Header closeButton>
          <Modal.Title>Error</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <div className="flex justify-center items-center align-center text-center p-2">
            <BsEmojiFrown
              size={50}
              color="#047E35"
              className="flex justify-center items-center "
            />
          </div>

          <div>{modalContent}</div>
        </Modal.Body>
      </Modal>
      <Header />
      <ToastContainer autoClose={2000} />
      <div style={{ width: "100%", overflowX: "hidden", overflowY: "hidden" }}>
        <div className="text-center successdoyenaccess">
          <div className="row">
            <div className="col-md-4"></div>
            <div className="col-md-4">
              <div
                style={{
                  backgroundColor: "#f5f8f8",
                  borderRadius: "10px",
                  paddingTop: "25px",
                  paddingBottom: "55px",
                }}
              >
                {completes ? (
                  <>
                    <img
                      src="../../images/Dollarsuccess.png"
                      alt="dollarsuccess"
                      style={{ paddingBottom: "30px" }}
                    />
                    <h2>Payment Successful</h2>
                    <h5 style={{ color: "#696969" }}>
                      Thank you for your payment
                    </h5>
                    <button
                      className="btn btn-success"
                      onClick={() => {
                        navigate("/doyenaccess");
                      }}
                    >
                      Back to Doyen Access
                    </button>
                  </>
                ) : (
                  <>
                    <h2>Almost through processing, please wait...</h2>
                  </>
                )}
              </div>
            </div>
            <div className="col-md-4"></div>
          </div>
        </div>
      </div>
      <br />
      <br />
      <br />
      <Footer />
    </div>
  );
};

export default DoyenaccessSuccess;
